import styles from './GlobalSearch.module.scss';
import { Dispatch, SetStateAction, useEffect } from 'react';
import SearchBarAndIcon from './Components/SearchBarAndIcon/SearchBarAndIcon';
import useSearchResultFetcher, { GlobalSearchResult } from './useSearchResultFetcher';
import { plusPurpleCircle } from '../../assets/hostedassets';
import AddToWatchlistDropdown from '../../modules/Investor/Portfolio/components/AddToWatchlist/AddToWatchlistDropdown';

type GlobalSearchProps = {
    showSearch: boolean;
    setShowSearch: Dispatch<SetStateAction<boolean>>;
};

const GlobalSearch = (props: GlobalSearchProps) => {
    const { showSearch, setShowSearch } = props;
    const {
        setSearchText,
        searchText,
        searchResults,
        navigateOrAddLead,
        setSearchResults,
        fetchCompanyInfoForResult,
        handleAddNewFlow,
        searchLoading,
    } = useSearchResultFetcher();

    const handleSelectAlreadyAdded = async (result: GlobalSearchResult) => {
        const accessType = result.companyAccessType || '';
        const resultWithGroup = { ...result, companyAccessType: accessType };
        setShowSearch(false);
        navigateOrAddLead(result.orgId, accessType, resultWithGroup, searchText);
    };

    const handleSelectAddNew = async (result: GlobalSearchResult) => {
        const accessType = result.companyAccessType || '';
        const resultWithGroup = { ...result, companyAccessType: accessType };
        setShowSearch(false);
        await handleAddNewFlow({
            baseResult: resultWithGroup,
            accessType,
            searchTextValue: searchText,
            initialPrefillLoadingFields: { website: true, brand: true },
            overwriteIdentifierFromCompanyInfo: true,
        });
    };

    const handleFooterAddNew = async () => {
        setShowSearch(false);
        const syntheticResult = {
            orgId: null,
            orgName: searchText,
            websiteUrl: '',
        };
        await handleAddNewFlow({
            baseResult: syntheticResult,
            accessType: '',
            searchTextValue: searchText,
            initialPrefillLoadingFields: { identifier: true, website: true, brand: true },
            overwriteIdentifierFromCompanyInfo: true,
            isAddUsingSearchText: true,
        });
    };
    useEffect(() => {
        if (!showSearch) {
            setSearchText('');
            setSearchResults(null);
        }
    }, [showSearch]);

    return (
        <div style={{ position: 'relative' }}>
            {showSearch ? <div className={styles.SearchBackdrop} onClick={() => setShowSearch(false)} /> : null}
            <div
                className={`${styles.GlobalSearchWrapper} ${
                    showSearch ? styles.GlobalSearchWrapperExpanded : styles.GlobalSearchWrapperCompact
                }`}
            >
                <SearchBarAndIcon
                    setSearchText={setSearchText}
                    searchText={searchText}
                    showSearch={showSearch}
                    onCrossIconClick={() => setShowSearch(false)}
                    onSearchIconClick={() => setShowSearch(!showSearch)}
                    searchLoading={searchLoading}
                />
            </div>
            <div style={{ position: 'relative', height: 'auto' }}>
                <AddToWatchlistDropdown
                    visible
                    searchText={searchText}
                    searchResults={searchResults}
                    wrapperClassName={styles.SearchResults}
                    onSelectAlreadyAdded={handleSelectAlreadyAdded}
                    onSelectAddNew={handleSelectAddNew}
                    footerVisible={searchText.length >= 3}
                    footerLabel={`Add using "${searchText}"`}
                    onFooterAddNew={handleFooterAddNew}
                />
            </div>
        </div>
    );
};

export default GlobalSearch;
